/* unplugin-vue-components disabled */const { ref, computed, nextTick, onBeforeMount } = require('vue');
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-48f7af60"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "program-panel-wrap" };
const _hoisted_2 = _withScopeId(() => (0, vue_2.createElementVNode)("span", {
    class: "label",
    style: { "display": "block" }
}, "当前程序", -1));
const _hoisted_3 = { class: "button" };
const _hoisted_4 = { class: "content-header" };
const _hoisted_5 = { style: { "padding": "5px" } };
const _hoisted_6 = _withScopeId(() => (0, vue_2.createElementVNode)("div", { style: { "flex": "1" } }, null, -1));
const _hoisted_7 = { class: "content-header" };
const _hoisted_8 = { style: { "padding": "5px" } };
const _hoisted_9 = { class: "content-header" };
const _hoisted_10 = { class: "dialog-footer" };
const _hoisted_11 = { class: "dialog-footer" };
const _hoisted_12 = { class: "robot-brand-wrap" };
const _hoisted_13 = _withScopeId(() => (0, vue_2.createElementVNode)("span", null, "机器人品牌", -1));
const _hoisted_14 = { style: { "text-align": "right" } };
const _hoisted_15 = { class: "process-group-item" };
const _hoisted_16 = { id: "process-group-add-wrap" };
const model_1 = require("@/model");
const work_1 = require("@/store/modules/work");
const api_1 = tslib_1.__importDefault(require("@/api"));
const PathPointPanel_vue_1 = tslib_1.__importDefault(require("./components/PathPointPanel.vue"));
const ProgramForm_vue_1 = tslib_1.__importDefault(require("./components/ProgramForm.vue"));
const IOPanel_vue_1 = tslib_1.__importDefault(require("./components/IOPanel.vue"));
const loading_1 = require("@/utils/loading");
const one_message_1 = require("@/utils/one_message");
const utils_1 = require("@/utils");
const CoordPanel_vue_1 = tslib_1.__importDefault(require("./components/CoordPanel.vue"));
const index_vue_1 = tslib_1.__importDefault(require("@/components/DeleteBtn/index.vue"));
const index_vue_2 = tslib_1.__importDefault(require("@/components/SensitiveInput/index.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'index',
    emits: ['addVar', 'delVar'],
    setup(__props, { emit: __emit }) {
        const store = (0, work_1.useWork)();
        const isAddVarVisable = ref(false);
        const isAddProgramVisabel = ref(false);
        const programForm = ref({
            name: ''
        });
        const panleName = { globalVars: 'globalVars', partVar: 'partVar', ioList: 'ioList', pathPoint: 'pathPoint', coord: 'coord' };
        const collapseModel = ref(panleName.pathPoint);
        const processDialog = ref(false);
        const options = computed(() => {
            var _a;
            return (_a = model_1.Project.current()) === null || _a === void 0 ? void 0 : _a.findMachineByType(model_1.ENTITY_TYPE.ROBOT).map((e) => {
                return {
                    value: e.id,
                    label: e.name,
                    children: e.code.programs.map((code) => {
                        return {
                            value: code.id,
                            label: code.name
                        };
                    })
                };
            });
        });
        const isOnDrag = ref(false);
        const suportBrand = ref();
        const translateBrand = ref('elite2');
        const translateDialog = ref(false);
        const curRobot = computed(() => { var _a; return ((_a = model_1.Project.current()) === null || _a === void 0 ? void 0 : _a.curProgram.robot) || {}; });
        const curProgram = computed(() => { var _a; return (_a = model_1.Project.current()) === null || _a === void 0 ? void 0 : _a.curProgram.program; });
        const processGroups = computed(() => curRobot.value.code.processGroups);
        const isAddToGlobal = ref(false);
        const newVar = ref({
            name: '',
            powerFailureProtect: false,
            isStatic: false,
            type: model_1.VAL_TYPE_NAME.DOUBLE,
            val: '',
            initVal: 0
        });
        const globalVars = computed(() => {
            if (!curRobot.value || !curRobot.value.code) {
                return [];
            }
            return curRobot.value.code.globalVars;
        });
        const partVar = computed(() => {
            if (!curProgram.value) {
                return [];
            }
            return curProgram.value.localVars;
        });
        const curSelect = computed(() => {
            var _a, _b, _c;
            let pg = (_a = model_1.Project.current()) === null || _a === void 0 ? void 0 : _a.curProgram;
            return [(_b = pg === null || pg === void 0 ? void 0 : pg.robot) === null || _b === void 0 ? void 0 : _b.id, (_c = pg === null || pg === void 0 ? void 0 : pg.program) === null || _c === void 0 ? void 0 : _c.id];
        });
        const isEditProgram = ref(false);
        const isAddProcessGroup = ref(false);
        const newProcessGroupName = ref();
        const isOnProcessGroupDrag = ref(false);
        const processGroupsEl = ref();
        const checkName = (name) => {
            var _a;
            if (name === '') {
                isAddProcessGroup.value = false;
                return false;
            }
            let patrn = /[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/im;
            if (patrn.test(name)) {
                (0, one_message_1.oneMessage)({ message: '名称不能含有特殊字符，请重新修改！', type: 'error' });
                return false;
            }
            if (name.indexOf(' ') !== -1) {
                (0, one_message_1.oneMessage)({ message: '名称不能含有空格，请重新修改！', type: 'error' });
                return false;
            }
            if (name.length > 15) {
                (0, one_message_1.oneMessage)({ message: '名称不能超过15个字符！', type: 'error' });
                return false;
            }
            let processGroups = ((_a = curRobot.value) === null || _a === void 0 ? void 0 : _a.code.processGroups) || [];
            let isSameName = !!processGroups.find(group => group.name === name);
            if (isSameName) {
                (0, one_message_1.oneMessage)({ message: '名称重复，请重新修改！', type: 'error' });
            }
            return !isSameName;
        };
        const handleNewProcessGroup = () => {
            if (!checkName(newProcessGroupName.value))
                return;
            curRobot.value.code.addNewProcessGroup(newProcessGroupName.value);
            nextTick(() => processGroupsEl.value.scrollTo(0, processGroupsEl.value.scrollHeight));
            newProcessGroupName.value = '';
            isAddProcessGroup.value = false;
        };
        const handleDialogClose = () => {
            isAddProcessGroup.value = false;
            newProcessGroupName.value = '';
        };
        const onSortEnd = (event) => {
            const { oldIndex, newIndex } = event;
            const formGroup = processGroups.value[oldIndex];
            const toGroup = processGroups.value[newIndex];
            curRobot.value.code.moveProcessGroup(oldIndex, newIndex);
        };
        const coordListWrapEl = ref();
        const pathPointListWrapEl = ref();
        const ioPanelListWrapEl = ref();
        const ioPanelEl = ref();
        const coordPanelEl = ref();
        const pathPointPanelEl = ref();
        const IO_Option = computed(() => ioPanelEl.value ? ioPanelEl.value.NEW_IO_OPTIONS : []);
        const pathPointOptions = computed(() => { var _a; return (_a = pathPointPanelEl.value) === null || _a === void 0 ? void 0 : _a.NAMES; });
        const ioDropdownRef = ref();
        const pathPointDropdownRef = ref();
        const isProgramFormLoading = ref(false);
        function handleNewCoord(e) {
            e.stopPropagation();
            if (!coordPanelEl.value)
                return;
            coordPanelEl.value.handleNewCoord();
            if (!coordListWrapEl.value) {
                return;
            }
            nextTick(() => coordListWrapEl.value.scrollTo({ top: coordListWrapEl.value.scrollHeight }));
        }
        function handleNewPathPoint(command) {
            if (!pathPointPanelEl.value)
                return;
            pathPointPanelEl.value.handleNewPathPoint(command);
            if (!pathPointListWrapEl.value) {
                return;
            }
            nextTick(() => pathPointListWrapEl.value.scrollTo({ top: pathPointListWrapEl.value.scrollHeight }));
        }
        function handleNewIOVar(command) {
            if (!ioPanelEl.value) {
                return;
            }
            ioPanelEl.value.handleNewIOVar(command);
            if (!ioPanelListWrapEl.value) {
                return;
            }
            nextTick(() => ioPanelListWrapEl.value.scrollTo({ top: ioPanelListWrapEl.value.scrollHeight }));
        }
        function handleAddProgram() {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                isProgramFormLoading.value = true;
                try {
                    isEditProgram.value = false;
                    if (!programFormItemRef.value && !programFormItemRef.value.programFormRef)
                        return;
                    let valid = yield programFormItemRef.value.programFormRef.validate();
                    if (!valid)
                        return;
                    let project = model_1.Project.current();
                    let newProgram = project.curProgram.robot.createProgram(programForm.value.name);
                    project.curProgram.robot.code.programs.push(newProgram);
                    project.selectProgram(project.curProgram.robot.id, newProgram.id);
                    isAddProgramVisabel.value = false;
                    programFormItemRef.value.programFormRef.resetFields();
                }
                catch (e) {
                    console.log(e);
                }
                finally {
                    isProgramFormLoading.value = false;
                }
            });
        }
        function handleEditProgram() {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                isProgramFormLoading.value = true;
                try {
                    if (curProgram.value && curProgram.value.name === '主程序')
                        return;
                    if (!programFormItemRef.value && !programFormItemRef.value.programFormRef)
                        return;
                    let valid = yield programFormItemRef.value.programFormRef.validate();
                    if (!valid || !curProgram.value)
                        return;
                    curProgram.value.name = programForm.value.name;
                    isAddProgramVisabel.value = false;
                    programFormItemRef.value.programFormRef.resetFields();
                    store.notifyChangeProgramName(curProgram.value);
                }
                catch (e) {
                    console.log(e);
                }
                finally {
                    isProgramFormLoading.value = false;
                }
            });
        }
        function handleOpenPathPointDropdown(e) {
            e.stopPropagation();
            if (!pathPointDropdownRef.value)
                return;
            pathPointDropdownRef.value.handleOpen();
        }
        function handleOpenIODropdown(e) {
            e.stopPropagation();
            if (!ioDropdownRef.value)
                return;
            ioDropdownRef.value.handleOpen();
        }
        function onChange(data) {
            model_1.Project.current().selectProgram(data[0], data[1]);
        }
        function onAddGlobalValClick(e) {
            e.stopPropagation();
            if (!curRobot.value)
                return;
            let nameIndex = 0;
            do {
                nameIndex++;
                newVar.value.name = `变量${nameIndex}`;
            } while (curRobot.value.code.globalVars.find(e => e.name == newVar.value.name));
            newVar.value.type = model_1.VAL_TYPE_NAME.DOUBLE;
            newVar.value.initVal = 0;
            isAddToGlobal.value = true;
            isAddVarVisable.value = true;
        }
        function onAddValClick(e) {
            e.stopPropagation();
            newVar.value.type = model_1.VAL_TYPE_NAME.DOUBLE;
            newVar.value.initVal = 0;
            isAddToGlobal.value = false;
            isAddVarVisable.value = true;
        }
        const programFormItemRef = ref();
        const emit = __emit;
        function handleAddPartOrGlobalVal() {
            if (!curRobot.value)
                return;
            let { name, isStatic, type, val, initVal } = newVar.value;
            let variable = curRobot.value.createVar(name, type, initVal, val, isStatic);
            if (isAddToGlobal.value) {
                curRobot.value.code.globalVars.push(variable);
                emit('addVar', variable.id);
            }
            else {
                console.log(curProgram.value);
                curProgram.value.localVars.push(variable);
            }
            isAddVarVisable.value = false;
        }
        function handleDelPartBtnClk(item) {
            let itemIndex = curProgram.value.localVars.indexOf(item);
            if (itemIndex != -1) {
                curProgram.value.localVars.splice(itemIndex, 1);
            }
        }
        function handleDelGlobalBtnClk(item) {
            if (!curRobot.value)
                return;
            curRobot.value.code.delGlobalVar(item.id);
            console.log('delVarIn');
            emit('delVar', item.id);
        }
        function handleDelProgram() {
            if (curProgram.value && curProgram.value.name === '主程序')
                return;
            console.log('confirm del program');
            curRobot.value.code.delProgram(curProgram.value.id);
            model_1.Project.current().selectProgram(curRobot.value.id, curRobot.value.code.programs[0].id);
        }
        function handleExportProgram() {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                (0, loading_1.openLoading)({
                    lock: true,
                    text: "正在生成程序"
                });
                try {
                    let project = model_1.Project.current();
                    let pg = model_1.ProgramsData.fromProject(project);
                    let data = pg.toJson();
                    data.brand = translateBrand.value;
                    console.log(data);
                    let blob = yield (0, api_1.default)('program.file', data);
                    if (blob.size > 0) {
                        let robot = project.curProgram.robot;
                        download(blob, `${project.project_name}_${robot.name}_程序.zip`);
                    }
                    translateDialog.value = false;
                }
                catch (e) {
                    (0, one_message_1.oneMessage)({ message: `生成程序失败! ${e.message || e}`, type: 'error' });
                    console.error(e);
                }
                finally {
                    (0, loading_1.closeLoading)();
                }
            });
        }
        function download(data, filename) {
            const blob = new Blob([data], { type: "application/octet-stream" });
            if (window.navigator['msSaveBlob']) {
                try {
                    window.navigator['msSaveBlob'](blob, filename);
                }
                catch (e) {
                    console.error(e);
                }
            }
            else {
                const downloadElement = document.createElement('a');
                const href = window.URL.createObjectURL(blob);
                downloadElement.href = href;
                downloadElement.download = filename;
                document.body.appendChild(downloadElement);
                downloadElement.click();
                document.body.removeChild(downloadElement);
                window.URL.revokeObjectURL(href);
            }
        }
        function onClickAddProgram() {
            programForm.value.name = '';
            isAddProgramVisabel.value = true;
            isEditProgram.value = false;
        }
        function onClickEditProgram() {
            if (curProgram.value && curProgram.value.name === '主程序') {
                return;
            }
            programForm.value.name = curProgram.value.name;
            isAddProgramVisabel.value = true;
            isEditProgram.value = true;
        }
        onBeforeMount(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
            suportBrand.value = yield (0, api_1.default)('program.support', {});
        }));
        function cleanup() {
            newVar.value = {
                name: '',
                powerFailureProtect: false,
                isStatic: false,
                type: '',
                val: '',
                initVal: ''
            };
        }
        return (_ctx, _cache) => {
            const _component_el_cascader = (0, vue_2.resolveComponent)("el-cascader");
            const _component_el_button = (0, vue_2.resolveComponent)("el-button");
            const _component_el_popconfirm = (0, vue_2.resolveComponent)("el-popconfirm");
            const _component_el_card = (0, vue_2.resolveComponent)("el-card");
            const _component_el_dropdown_item = (0, vue_2.resolveComponent)("el-dropdown-item");
            const _component_el_dropdown = (0, vue_2.resolveComponent)("el-dropdown");
            const _component_el_tab_pane = (0, vue_2.resolveComponent)("el-tab-pane");
            const _component_el_tabs = (0, vue_2.resolveComponent)("el-tabs");
            const _component_var_item = (0, vue_2.resolveComponent)("var-item");
            const _component_el_dialog = (0, vue_2.resolveComponent)("el-dialog");
            const _component_el_option = (0, vue_2.resolveComponent)("el-option");
            const _component_el_select = (0, vue_2.resolveComponent)("el-select");
            const _component_Switch = (0, vue_2.resolveComponent)("Switch");
            const _component_el_icon = (0, vue_2.resolveComponent)("el-icon");
            const _component_draggable = (0, vue_2.resolveComponent)("draggable");
            const _component_Plus = (0, vue_2.resolveComponent)("Plus");
            const _component_el_tooltip = (0, vue_2.resolveComponent)("el-tooltip");
            const _component_el_input = (0, vue_2.resolveComponent)("el-input");
            const _directive_auto_focus = (0, vue_2.resolveDirective)("auto-focus");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    true
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_card, { key: 0 }, {
                            default: (0, vue_2.withCtx)(() => {
                                var _a;
                                return [
                                    _hoisted_2,
                                    (0, vue_2.createVNode)(_component_el_cascader, {
                                        modelValue: (0, vue_2.unref)(curSelect),
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((0, vue_2.isRef)(curSelect) ? (curSelect).value = $event : null)),
                                        options: (0, vue_2.unref)(options),
                                        onChange: onChange,
                                        size: "small",
                                        style: { "width": "100%" }
                                    }, null, 8, ["modelValue", "options"]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                        (0, vue_2.createVNode)(_component_el_button, {
                                            class: "program-btn",
                                            size: "small",
                                            type: "primary",
                                            onClick: onClickAddProgram
                                        }, {
                                            default: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createTextVNode)("新增")
                                            ]),
                                            _: 1
                                        }),
                                        (0, vue_2.createVNode)(_component_el_popconfirm, {
                                            title: "确定删除这个程序吗？",
                                            onConfirm: handleDelProgram
                                        }, {
                                            reference: (0, vue_2.withCtx)(() => {
                                                var _a;
                                                return [
                                                    (0, vue_2.createVNode)(_component_el_button, {
                                                        class: "program-btn",
                                                        style: { "margin": "0px" },
                                                        disabled: (0, vue_2.unref)(curProgram) && ((_a = (0, vue_2.unref)(curProgram)) === null || _a === void 0 ? void 0 : _a.name) === '主程序',
                                                        size: "small"
                                                    }, {
                                                        default: (0, vue_2.withCtx)(() => [
                                                            (0, vue_2.createTextVNode)("删除 ")
                                                        ]),
                                                        _: 1
                                                    }, 8, ["disabled"])
                                                ];
                                            }),
                                            _: 1
                                        }),
                                        (0, vue_2.createVNode)(_component_el_button, {
                                            class: "program-btn",
                                            style: { "margin": "0px" },
                                            onClick: onClickEditProgram,
                                            disabled: (0, vue_2.unref)(curProgram) && ((_a = (0, vue_2.unref)(curProgram)) === null || _a === void 0 ? void 0 : _a.name) === '主程序',
                                            size: "small"
                                        }, {
                                            default: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createTextVNode)("重命名 ")
                                            ]),
                                            _: 1
                                        }, 8, ["disabled"])
                                    ])
                                ];
                            }),
                            _: 1
                        }))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createVNode)(_component_el_tabs, {
                        modelValue: (0, vue_2.unref)(collapseModel),
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((0, vue_2.isRef)(collapseModel) ? (collapseModel).value = $event : null))
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createVNode)(_component_el_tab_pane, {
                                name: panleName.pathPoint,
                                label: "路径及点"
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                        (0, vue_2.createVNode)(_component_el_dropdown, {
                                            size: "small",
                                            placeholder: "新增",
                                            onCommand: handleNewPathPoint,
                                            trigger: "click",
                                            "hide-on-click": false,
                                            ref_key: "pathPointDropdownRef",
                                            ref: pathPointDropdownRef
                                        }, {
                                            dropdown: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(pathPointOptions), (item) => {
                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", { key: item }, [
                                                            (0, vue_2.createVNode)(_component_el_dropdown_item, { command: item }, {
                                                                default: (0, vue_2.withCtx)(() => [
                                                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(item), 1)
                                                                ]),
                                                                _: 2
                                                            }, 1032, ["command"])
                                                        ]));
                                                    }), 128))
                                                ])
                                            ]),
                                            default: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createVNode)(_component_el_button, {
                                                    type: "primary",
                                                    onClick: handleOpenPathPointDropdown,
                                                    size: "small"
                                                }, {
                                                    default: (0, vue_2.withCtx)(() => [
                                                        (0, vue_2.createTextVNode)("新增")
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }, 512),
                                        _hoisted_6,
                                        (0, vue_2.createVNode)(_component_el_button, {
                                            size: "small",
                                            onClick: _cache[1] || (_cache[1] = ($event) => (processDialog.value = true))
                                        }, {
                                            default: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createTextVNode)("管理工序类型")
                                            ]),
                                            _: 1
                                        }),
                                        (0, vue_2.createVNode)(_component_el_button, {
                                            size: "small",
                                            onClick: _cache[2] || (_cache[2] = (0, vue_2.withModifiers)(($event) => (isOnDrag.value = !(0, vue_2.unref)(isOnDrag)), ["stop"]))
                                        }, {
                                            default: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(isOnDrag) ? '完成' : '排序'), 1)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    (0, vue_2.createElementVNode)("div", {
                                        class: "main-content",
                                        ref_key: "pathPointListWrapEl",
                                        ref: pathPointListWrapEl
                                    }, [
                                        (0, vue_2.createVNode)(PathPointPanel_vue_1.default, {
                                            ref_key: "pathPointPanelEl",
                                            ref: pathPointPanelEl,
                                            isOnDrag: (0, vue_2.unref)(isOnDrag)
                                        }, null, 8, ["isOnDrag"])
                                    ], 512)
                                ]),
                                _: 1
                            }, 8, ["name"]),
                            (0, vue_2.createVNode)(_component_el_tab_pane, {
                                name: panleName.ioList,
                                label: "I/O信号口"
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                        (0, vue_2.createVNode)(_component_el_dropdown, {
                                            size: "small",
                                            placeholder: "新增",
                                            onCommand: handleNewIOVar,
                                            trigger: "click",
                                            "hide-on-click": false,
                                            ref_key: "ioDropdownRef",
                                            ref: ioDropdownRef
                                        }, {
                                            dropdown: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createElementVNode)("div", _hoisted_8, [
                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(IO_Option), (group) => {
                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                            key: group.value
                                                        }, [
                                                            (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(group.label), 1),
                                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(group.options, (item) => {
                                                                return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_dropdown_item, {
                                                                    key: item.value,
                                                                    command: [group.value, item.value]
                                                                }, {
                                                                    default: (0, vue_2.withCtx)(() => [
                                                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(item.label), 1)
                                                                    ]),
                                                                    _: 2
                                                                }, 1032, ["command"]));
                                                            }), 128))
                                                        ]));
                                                    }), 128))
                                                ])
                                            ]),
                                            default: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createVNode)(_component_el_button, {
                                                    type: "primary",
                                                    onClick: handleOpenIODropdown,
                                                    size: "small"
                                                }, {
                                                    default: (0, vue_2.withCtx)(() => [
                                                        (0, vue_2.createTextVNode)("新增")
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }, 512)
                                    ]),
                                    (0, vue_2.createElementVNode)("div", {
                                        class: "main-content",
                                        ref_key: "ioPanelListWrapEl",
                                        ref: ioPanelListWrapEl
                                    }, [
                                        (0, vue_2.createVNode)(IOPanel_vue_1.default, {
                                            ref_key: "ioPanelEl",
                                            ref: ioPanelEl
                                        }, null, 512)
                                    ], 512)
                                ]),
                                _: 1
                            }, 8, ["name"]),
                            (0, vue_2.createVNode)(_component_el_tab_pane, {
                                name: panleName.coord,
                                label: "坐标系"
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createElementVNode)("div", _hoisted_9, [
                                        (0, vue_2.createVNode)(_component_el_button, {
                                            size: "small",
                                            placeholder: "新增",
                                            onClick: handleNewCoord,
                                            type: "primary"
                                        }, {
                                            default: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createTextVNode)("新增")
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    (0, vue_2.createElementVNode)("div", {
                                        class: "main-content",
                                        ref_key: "coordListWrapEl",
                                        ref: coordListWrapEl
                                    }, [
                                        (0, vue_2.createVNode)(CoordPanel_vue_1.default, {
                                            ref_key: "coordPanelEl",
                                            ref: coordPanelEl
                                        }, null, 512)
                                    ], 512)
                                ]),
                                _: 1
                            }, 8, ["name"])
                        ]),
                        _: 1
                    }, 8, ["modelValue"]),
                    (!(0, vue_2.unref)(utils_1.Utils).isIPad())
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_button, {
                            key: 1,
                            style: { "height": "40px" },
                            type: "primary",
                            onClick: _cache[4] || (_cache[4] = ($event) => (translateDialog.value = true))
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createTextVNode)("导出项目")
                            ]),
                            _: 1
                        }))
                        : (0, vue_2.createCommentVNode)("", true)
                ]),
                (0, vue_2.createVNode)(_component_el_dialog, {
                    modelValue: (0, vue_2.unref)(isAddVarVisable),
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((0, vue_2.isRef)(isAddVarVisable) ? (isAddVarVisable).value = $event : null)),
                    width: "320px",
                    "align-center": "",
                    onClosed: cleanup,
                    title: (0, vue_2.unref)(isAddToGlobal) ? '新增全局变量' : '新增局部变量'
                }, {
                    footer: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("span", _hoisted_10, [
                            (0, vue_2.createVNode)(_component_el_button, {
                                type: "primary",
                                onClick: handleAddPartOrGlobalVal
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createTextVNode)("确定")
                                ]),
                                _: 1
                            }),
                            (0, vue_2.createVNode)(_component_el_button, {
                                onClick: _cache[5] || (_cache[5] = ($event) => (isAddVarVisable.value = false))
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createTextVNode)("取消")
                                ]),
                                _: 1
                            })
                        ])
                    ]),
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createVNode)(_component_var_item, { valItem: (0, vue_2.unref)(newVar) }, null, 8, ["valItem"])
                    ]),
                    _: 1
                }, 8, ["modelValue", "title"]),
                (0, vue_2.createVNode)(_component_el_dialog, {
                    modelValue: (0, vue_2.unref)(isAddProgramVisabel),
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((0, vue_2.isRef)(isAddProgramVisabel) ? (isAddProgramVisabel).value = $event : null)),
                    width: "320px",
                    "align-center": "",
                    title: (0, vue_2.unref)(isEditProgram) ? '重命名' : '新增程序'
                }, {
                    footer: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("span", _hoisted_11, [
                            (0, vue_2.createVNode)(_component_el_button, {
                                type: "primary",
                                loading: (0, vue_2.unref)(isProgramFormLoading),
                                onClick: _cache[7] || (_cache[7] = ($event) => ((0, vue_2.unref)(isEditProgram) ? handleEditProgram() : handleAddProgram()))
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createTextVNode)("确定")
                                ]),
                                _: 1
                            }, 8, ["loading"]),
                            (0, vue_2.createVNode)(_component_el_button, {
                                onClick: _cache[8] || (_cache[8] = ($event) => (isAddProgramVisabel.value = false))
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createTextVNode)("取消")
                                ]),
                                _: 1
                            })
                        ])
                    ]),
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createVNode)(ProgramForm_vue_1.default, {
                            form: (0, vue_2.unref)(programForm),
                            curRobot: (0, vue_2.unref)(curRobot),
                            isEdit: (0, vue_2.unref)(isEditProgram),
                            ref_key: "programFormItemRef",
                            ref: programFormItemRef
                        }, null, 8, ["form", "curRobot", "isEdit"])
                    ]),
                    _: 1
                }, 8, ["modelValue", "title"]),
                (0, vue_2.createVNode)(_component_el_dialog, {
                    title: "导出项目",
                    modelValue: (0, vue_2.unref)(translateDialog),
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((0, vue_2.isRef)(translateDialog) ? (translateDialog).value = $event : null)),
                    width: "400"
                }, {
                    footer: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createVNode)(_component_el_button, {
                            onClick: _cache[11] || (_cache[11] = ($event) => (translateDialog.value = false))
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createTextVNode)("取消")
                            ]),
                            _: 1
                        }),
                        (0, vue_2.createVNode)(_component_el_button, {
                            type: "primary",
                            onClick: handleExportProgram
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createTextVNode)(" 确认 ")
                            ]),
                            _: 1
                        })
                    ]),
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_12, [
                            _hoisted_13,
                            (0, vue_2.createVNode)(_component_el_select, {
                                modelValue: (0, vue_2.unref)(translateBrand),
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((0, vue_2.isRef)(translateBrand) ? (translateBrand).value = $event : null))
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(suportBrand), (item, key) => {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_option, {
                                            key: key,
                                            label: key,
                                            value: item
                                        }, null, 8, ["label", "value"]));
                                    }), 128))
                                ]),
                                _: 1
                            }, 8, ["modelValue"])
                        ])
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                (0, vue_2.createVNode)(_component_el_dialog, {
                    modelValue: (0, vue_2.unref)(processDialog),
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((0, vue_2.isRef)(processDialog) ? (processDialog).value = $event : null)),
                    title: "管理工序类型",
                    onClose: handleDialogClose,
                    modal: false,
                    "append-to-body": true,
                    "destroy-on-close": true,
                    draggable: "",
                    width: "290",
                    center: true,
                    fullscreen: false,
                    style: { "position": "absolute", "right": "300px" }
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_14, [
                            (0, vue_2.createVNode)(_component_el_button, {
                                style: { "margin-bottom": "5px" },
                                size: "small",
                                onClick: _cache[13] || (_cache[13] = ($event) => (isOnProcessGroupDrag.value = !(0, vue_2.unref)(isOnProcessGroupDrag)))
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(isOnProcessGroupDrag) ? '完成排序' : '排序'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        (0, vue_2.createElementVNode)("div", {
                            id: "process-group-list",
                            ref_key: "processGroupsEl",
                            ref: processGroupsEl
                        }, [
                            (0, vue_2.createVNode)(_component_draggable, {
                                modelValue: (0, vue_2.unref)(processGroups),
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((0, vue_2.isRef)(processGroups) ? (processGroups).value = $event : null)),
                                onEnd: onSortEnd,
                                "item-key": "`processGroup${id}`",
                                filter: ".process-group-item",
                                disabled: !(0, vue_2.unref)(isOnProcessGroupDrag)
                            }, {
                                item: (0, vue_2.withCtx)(({ index }) => [
                                    (0, vue_2.createElementVNode)("div", null, [
                                        index
                                            ? (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_icon, {
                                                key: 0,
                                                class: "darg-icon"
                                            }, {
                                                default: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createVNode)(_component_Switch)
                                                ]),
                                                _: 1
                                            }, 512)), [
                                                [vue_2.vShow, (0, vue_2.unref)(isOnProcessGroupDrag)]
                                            ])
                                            : (0, vue_2.createCommentVNode)("", true),
                                        (0, vue_2.createElementVNode)("div", _hoisted_15, [
                                            (0, vue_2.createVNode)(index_vue_2.default, {
                                                model: (0, vue_2.unref)(processGroups)[index].name,
                                                "onUpdate:model": ($event) => (((0, vue_2.unref)(processGroups)[index].name) = $event),
                                                beforeChange: checkName,
                                                maxlength: 15
                                            }, null, 8, ["model", "onUpdate:model"]),
                                            (0, vue_2.createVNode)(index_vue_1.default, {
                                                onDelConfirm: ($event) => ((0, vue_2.unref)(curRobot).delProcessGroup((0, vue_2.unref)(processGroups)[index].id)),
                                                title: `确定删除 ${(0, vue_2.unref)(processGroups)[index].name} 吗？`,
                                                unvisibility: index == 0
                                            }, null, 8, ["onDelConfirm", "title", "unvisibility"])
                                        ])
                                    ])
                                ]),
                                _: 1
                            }, 8, ["modelValue", "disabled"])
                        ], 512),
                        (0, vue_2.createElementVNode)("div", _hoisted_16, [
                            (0, vue_2.createVNode)(_component_el_tooltip, {
                                effect: "dark",
                                content: "新增"
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.withDirectives)((0, vue_2.createVNode)(_component_el_icon, {
                                        onClick: _cache[15] || (_cache[15] = ($event) => (isAddProcessGroup.value = true))
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createVNode)(_component_Plus)
                                        ]),
                                        _: 1
                                    }, 512), [
                                        [vue_2.vShow, !(0, vue_2.unref)(isAddProcessGroup)]
                                    ])
                                ]),
                                _: 1
                            }),
                            ((0, vue_2.unref)(isAddProcessGroup))
                                ? (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_input, {
                                    key: 0,
                                    modelValue: (0, vue_2.unref)(newProcessGroupName),
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((0, vue_2.isRef)(newProcessGroupName) ? (newProcessGroupName).value = $event : null)),
                                    onBlur: handleNewProcessGroup,
                                    formatter: 0,
                                    maxlength: 15
                                }, null, 8, ["modelValue"])), [
                                    [_directive_auto_focus]
                                ])
                                : (0, vue_2.createCommentVNode)("", true)
                        ])
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ], 64));
        };
    }
});
